const Title = ({children}) => (
    <h4 className="title">
        {children}
    </h4>
)

export default Title
